import CookiePolicy from '../components/cookiePolicy';

export default CookiePolicy;